<template>
  <div class="index" :style="{ paddingTop: statusBar + 'rem' }">
    <Header ref="header" title="重置密码" :back="true" left="" />
    <div class="windowmain">
      <div class="boxmain">
        <div class="boxstep">
          <div class="stepitem stepitemactive" style="flex:0.7">
            <p class="itemp1">1</p>
            <p class="stepline"></p>
            <p class="itemp2">填写用户名</p>
          </div>
            <div class="stepitem stepitemactive" style="flex:0.8">
            <p class="itemp1">2</p>
            <p class="stepline2"></p>
            <p class="itemp2">安全验证</p>
          </div>
           <div class="stepitem stepitemactive" style="flex:0.8">
            <p class="itemp1">3</p>
             <p class="stepline3"></p>
            <p class="itemp2">重置密码</p>
          </div>
           <div class="stepitem" style="flex:0.5">
            <p class="itemp1">4</p>
           
            <p class="itemp2">完成</p>
          </div>
        </div>
           <div class="v_showdiv"></div>
        <div class="boxinput">
           <p class="boxTitle">重置密码</p>
          <div class="filed-vertical vertical1">
            <div class="lable"><span>*</span>登录用户名</div>
            <van-field
              v-model="certName"
              class="input"
              disabled
              readonly
              placeholder="请输入姓名"
            />
          </div>
            <div class="filed-vertical">
            <div class="lable"><span>*</span>登录密码</div>
             <van-field
              v-model="certpsd"
              type="password"
              class="input"
                maxlength="20"
              v-show="downIcon1"
              @click-right-icon="eye1"
              right-icon="eye"
              error-message
              placeholder="请输入密码"
            />
             <van-field
              v-model="certpsd"
              type="text"
              class="input"
               maxlength="20"
              v-show="!downIcon1"
              @click-right-icon="eye1"
              right-icon="eye-o"
              error-message
              placeholder="请输入密码"
            />
          </div>
             <div class="filed-vertical">
            <div class="lable"><span>*</span>确认登录密码</div>
            <van-field
              v-model="cerpsed"
              type="password"
              class="input"
                maxlength="20"
              v-show="downIcon"
              @click-right-icon="eye"
              right-icon="eye"
              error-message
              placeholder="请输入密码"
            />
             <van-field
              v-model="cerpsed"
              type="text"
              class="input"
               maxlength="20"
              v-show="!downIcon"
              @click-right-icon="eye"
              right-icon="eye-o"
              error-message
              placeholder="请输入密码"
            />
          </div>
        </div>
      </div>

      <div style="margin: 16px">
        <van-button
          type="primary"
          class="btn1"
          size="large"
          @click="fromSubmit()"
          >确认</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>

import Header from "@/components/Header";

import {
  Form,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Field,
  Col,
  Row,
  Button,
  Picker,
  Popup,
  Icon,
    Step,
  Steps,
  Toast,
  DatetimePicker,
  NoticeBar,
} from "vant";

export default {
  name: "swforgotpsd",
  data() {
    return {
      certName: "",
      certpsd:'',
      cerpsed:"",
      certNo: "",
      ieFlag: "",
       base64img: '',
       pacClientId:'',
      downIcon:true,
      downIcon1:true,
       checkCode: '',
      passdType: 'password',
      orginTypeArray: ["进境1", "出境2"],
      orginTypeData: [
        { codeName: "进境", codeValue: "I" },
        { codeName: "出境", codeValue: "E" },
      ],
      model: {
        param: {
          seqNo: "",
          billType: "23003",
          projectSubCode: "2",
          status: "",
          pageSize: 10,
          pageNum: 0,
          businessNo: "",
          businessNo1: "",
          carNo: "",
          declareName: "",
          startDate: "",
          endDate: "",
        },
      },
      view: {
        searchForm: {
          seqNo: "",
          status: "",
          statusName: "所有状态",
          businessNo: "",
          businessNo1: "",
          carNo: "",
          declareName: "",
          startDate: "",
          endDate: "",
        },
        statusList: [],
      },
      bizCode: "FACE_ALIPAY_SDK",
      statusBar: 0,
      value: "",
    };
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
  
  },

  methods: {
    fromSubmit() {
       this.$router.push({
            path: '/swforgotend',
           
          });
    },
 eye(){
      this.downIcon =!this.downIcon
    },
    eye1(){
      this.downIcon1 =!this.downIcon1
    },
    onClickIcon(){
       this.passdType = this.passdType === 'password' ? 'text' : 'password'
    }

    
  },

  components: {
    Header,

    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [DatetimePicker.name]: DatetimePicker,
    [NoticeBar.name]: NoticeBar,
     [Step.name]: Step,
    [Steps.name]: Steps,
     [Icon.name]: Icon,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/public.scss";
@import "@/views/css/userindex.scss";
// ::v-deep .van-cell {
//   display: block;
// }
// ::v-deep .van-cell::after {
//   border-bottom: 0px;
// }

.windowmain {
  width: 100%;
  .boxmain {
    width: 100%;
    .boxTitle {
      font-size: 13px;
      color: #333;
      font-weight: bold;
     margin-bottom: 14px;
    }
     .boxstep{
      width: auto;
      background: #fff;
      height: auto;
      display: flex;
          padding: 14px 11px 16px 11px;
      .stepitem{
        flex:1;
        position: relative;
        text-align: center;
        .stepline{
          position: absolute;
          width:42px;
          height: 1px;
          background: #d5d5d5;
          left: 70px;
    top: 9px;
        }
          .stepline2{
          position: absolute;
          width:50px;
          height: 1px;
          background: #d5d5d5;
          left: 76px;
    top: 9px;
        }
        .stepline3{
          position: absolute;
          width:42px;
          height: 1px;
          background: #d5d5d5;
          left: 70px;
    top: 9px;
        }
        .itemp1{
          width: 17px;
      height: 17px;
      background: #d5d5d5;
      font-size: 11px;
      color:#fff;
          text-align: center;
    border-radius: 50%;
    line-height: 18px;
    display: block;
    position: relative;
    margin: 0 auto;
        }
         .itemp2{
          font-size: 12px;
          color: #999;
          margin-top: 6px;
         }
      }
      .stepitemactive{
        .itemp1{
          background: #00599c;
        }
        .itemp2{
           color: #00599c;
        }
          .stepline {
          background: #00599c;
        }
         .stepline2 {
          background: #00599c;
        }
      }
    }
  }
     .v_showdiv{
    height: 12px;
    background: #f7f8fa;
  }
  .boxinput {
  
    height: auto;
    border-radius: 4px;
    background: #fff;
    padding: 10px 20px;
   
    .filed-vertical {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      margin-bottom: 8px;
      .lable {
        font-size: 12px;
        color: #333;
      }
      .lable span {
        display: inline-block;
        color: #ee0a24;
        margin-right: 4px;
      }
           ::v-deep.van-cell{
        padding: 0px;
      }
      ::v-deep .van-cell .van-field__body{
        border: 1px solid #ddd;
        padding: 4px 9px;
        border-radius: 4px;
        margin-top: 6px;
      }
      ::v-deep .van-cell .van-field__body:hover {
        border: 1px solid #00599c;
        box-shadow: 0px 2px 5px 3px raga(0, 89, 156, 0.1);
      }
   
      // ::v-deep .van-field__control:focus{
      //   border: 1px solid #00599c;
      //   box-shadow:  0px 2px 5px 3px raga(0,89,156,0.10);
      // }
    }
  }


   ::v-deep .boxinput  .vertical1 .van-cell .van-field__body{
        border: 1px solid #ddd;
        padding: 4px 9px;
        background: #efefef;
        border-radius: 4px;
        margin-top: 4px;
      }
   ::v-deep  .boxinput .vertical1 .van-cell .van-field__body:hover{
     border: 1px solid #ddd;;
        box-shadow:  none;;
   }
  .ftBton {
    padding: 0px 15px;
    font-size: 11px;
    color: #999;
  }

}
</style>